export default "__VITE_ASSET__TntG$v0P__"